import { Badge } from '@cloudflare/kumo'
import type { Health } from '../types'
import { healthStyle } from '../health'

/** Health pill built on Kumo's Badge. Dot appearance for most states; blocked
 *  renders as a filled danger badge so it visually outranks a plain error. */
export function StatusBadge({ health }: { health: Health }) {
  const s = healthStyle(health)
  return (
    <Badge variant={s.badge} appearance={s.dot ? 'dot' : 'filled'}>
      {s.label}
    </Badge>
  )
}
